import script from "./CookieDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CookieDialog.vue?vue&type=script&setup=true&lang=js"

import "./CookieDialog.vue?vue&type=style&index=0&id=53d88229&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53d88229"]])

export default __exports__